import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
      return _createElementVNode("div", {
        key: i,
        class: "tw-inline-block tw-mr-4"
      }, [
        _createElementVNode("a", {
          href: "",
          onClick: _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', i)), ["prevent"]),
          class: _normalizeClass({
          'sf-btn-primary': _ctx.modelValue == i,
          'sf-btn-secondary': _ctx.modelValue != i,
        })
        }, " Year " + _toDisplayString(i), 11, _hoisted_1)
      ])
    }), 64))
  ]))
}